module.exports = __webpack_public_path__ + "img/zi-bottom.e29f4f6a.png";